import { Config } from './types'

export const defaultConfig: Config = {
  sendMethod: 'post',
  serverUrl: 'https://track-server.zhiyitech.cn',
  showLog:  true,
  isDefaultReport: false,
  isListenClick: false,
  isListenSelections: true
}